import { render, staticRenderFns } from "./ShowFounder.vue?vue&type=template&id=0d96869d&"
import script from "./ShowFounder.vue?vue&type=script&lang=js&"
export * from "./ShowFounder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports